import { nanoid } from 'nanoid'

export default {
  unique () {
    return nanoid()
  }
}
